export default {
    manage_deleteWorkOrderType_title: "Delete Work Order Type",
    manage_deleteWorkOrderTypes_title: "Delete Work Order Types",
    manage_deleteWorkOrderTypes_description: "Are you sure you want to delete these work order types?",
    manage_deleteWorkOrderType_description: "Are you sure want to delete this Work Order Type?",
    manage_deleteWorkOrderType_successMessage: "Work Order Type deleted",
    manage_deleteWorkOrderTypes_successMessage: "Work Order Types deleted",
    manage_deleteWorkOrderTypes_are_in_use: "It is not possible to delete work order types in use",
}